const calcAngleFromDiameter = (diameter, distance) => Math.atan((diameter / 2) / distance);

export default calcAngleFromDiameter;
